import { type RouteLocation, type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';
import { routerHelper } from '@/services/router-helper';

const AllianceOverview = (): unknown => {
    return import(/* webpackPrefetch: true */ '@/pages/alliance-main-overview/alliance-main-overview.vue');
};

export const allianceOverviewRoute: RouteRecordRaw = {
    ...ROUTE_DATA.ALLIANCE_OVERVIEW_PAGE,
    components: {
        main: AllianceOverview
    },
    props: {
        main(route: RouteLocation): { allianceId?: number } {
            return { allianceId: routerHelper.parseParamToInt(route.params.id as string) };
        }
    }
};
